export const prefix = '/workout-plans' as const;

export const WorkoutEndpoints: Record<string, string> = {
  getHistory: `${prefix}/history`,
  getExercises: `${prefix}/workouts/`,
  completeWorkout: `${prefix}/workouts/completions`,
} as const;
